import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

type RewriteRule = {
  match: RegExp;
  rewrite: (path: string, times?: number) => string;
}

const rewriteRules: RewriteRule[] = [
  {
    match: /^\/project\/[^/]+$/i,
    rewrite: () => '/'
  },
  {
    match: /^\/chat\/[^/]+$/i,
    rewrite: () => '/'
  },
  {
    match: /^\/project\/[^/]+\/[^/]+\/chat\/[^/]+$/i,
    rewrite: (path: string, times: number = -1) => {
      const pathSegments = path.split('/')
      let count = Math.abs(times)
      pathSegments.pop()
      pathSegments.pop()
      count--
      while(count > 0 && pathSegments.length > 0){
        pathSegments.pop()
        count--
      }
      return pathSegments.join('/')
    }
  }
]

export default function useBack() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback((times: number = -1) => {
    if (
      window.history.state &&
      window.history.state.idx > 0 &&
      window.history.state.idx >= Math.abs(times)
    ) {
      navigate(times);
    } else {
      const path = location.pathname;
      const rule = rewriteRules.find(rule => rule.match.test(path))
      if (rule) {
        navigate(rule.rewrite(path), { replace: true });
      } else {
        const pathSegments = path.split('/')
        for(let i = 0; i < Math.abs(times); i++)
          pathSegments.pop()
        navigate(pathSegments.join('/'), { replace: true });
      }
    }
  }, [navigate, location]);
}